import {SuiModal, ComponentModalConfig, ModalSize} from "ng2-semantic-ui"
import { Component, OnInit, Input } from '@angular/core';
import {IImageModalContext} from '../../core/models/imageModalcontext.interface';

@Component({
    selector: 'image-confirm',
    template: `
<div class="header">{{ modal.context.title }}</div>
<div class="ui fluid image" >
    <img src="{{ modal.context.source}}" style="width: 100%; height: 100%;">
</div>
<div class="actions">
    <button class="ui red button" (click)="modal.deny(undefined)">Close</button>
</div>
`
})
export class ImageModalComponent {
    constructor(public modal:SuiModal<IImageModalContext, void, void>) {}
}
